var createDOMPurify = require('dompurify');
var DOMPurify = createDOMPurify(window);

module.exports = {
	capitalize: function (s) {
		if (s && s.length) {
			return s[0].toUpperCase() + s.slice(1);
		} else {
			return s;
		}
	},

	formatNumber: function (v) {
		// to make this clear, I'll assume an input of 10200200.003 and explain what

		// so now parts will be ['10200200', '003']
		var parts = ('' + v).split('.');
		var whole = parts[0]; // '10200200'
		var frac = parts[1] || ''; // '003'

		// make an array and go through it backwards
		whole = whole.split('');

		// whole is now ['0','0','2','0','0','2','0','1']
		whole.reverse();

		var whole2 = [];
		// so now we can reconstruct whole in whole2, adding
		// a comma every third character
		for (var i = 0; i < whole.length; i++) {
			if (i > 0 && i % 3 === 0) {
				whole2.push(',');
			}
			whole2.push(whole[i]);
		}

		whole2.reverse();
		whole = whole2.join('');

		return whole + (frac ? '.' + frac : '');
	},

	/**
	 * Removes <script> tags and any on* event handlers from untrusted HTML.
	 *
	 * @param  {String} html
	 * @return {String} safe HTML that won't contain any scripts
	 */
	stripScripts: function (html) {
		return DOMPurify.sanitize(html);
	},

	stripHTML: function (html) {
		var div = document.createElement('DIV');

		// strip out scripts for safety first
		html = this.stripScripts(html);

		// use innerHTML/textContent to catch other HTML nuances like &ldquo; and unicode entities
		div.innerHTML = html;

		return div.textContent || div.innerText || '';
	}
};
